/**
 * Format skill level with initial capital letter
 * @param {string} skillLevel - The skill level (beginner, average, advanced)
 * @returns {string} - Formatted skill level (Beginner, Average, Advanced)
 */
export function formatSkillLevel(skillLevel) {
  if (!skillLevel) return 'N/A';
  
  const formatted = skillLevel.charAt(0).toUpperCase() + skillLevel.slice(1).toLowerCase();
  return formatted;
}

